import { render, staticRenderFns } from "./Block2Creation.vue?vue&type=template&id=4cc958f8&scoped=true&"
import script from "./Block2Creation.vue?vue&type=script&lang=js&"
export * from "./Block2Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc958f8",
  null
  
)

export default component.exports